import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSparadRepportV2, onDeleteThiRapportV2, onEditThiRapportV2,onsetThisReportAsFav } from 'actions';
import { TextField,makeStyles, Typography, List, ListItem, ListItemAvatar, Tooltip, Avatar, ListItemText, ListItemSecondaryAction, IconButton,InputAdornment } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination'; // Import Pagination
import EjectIcon from '@material-ui/icons/Eject';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import DeleteThisSRapport from './DeleteThisSRapport/index';
import EditThisSRapport from './EditThisSRapport/index';
import IntlMessages from 'util/IntlMessages';
import SearchIcon from '@material-ui/icons/Search'; 
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles((theme) => ({
    demo: {
        backgroundColor: theme.palette.background.paper,
        display:"flex",
        flexDirection:"column",
        justifyContent:"space-between",
        height: '310px'
    },
    title: {
        margin: theme.spacing(1, 0, 1),
    },
    searchBar:{
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      maxWidth:180
    }
}));

function SparadRapport(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const SparadRapportV2 = useSelector((state) => state.accountsData.SparadRapportV2);
    const Userlista = useSelector((state) => state.accountsData.Userlista);
    const authUser = useSelector((state) => state.auth.authUser);
    React.useEffect(() => {
        dispatch(getSparadRepportV2(authUser.user_id, authUser.user_Afid));
    }, []);

    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [editem, seteditem] = useState({});
    const [delitem, setdelitem] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [currentPage, setCurrentPage] = useState(1); // State for current page
    const itemsPerPage = 5; // Number of items per page
    const [searchTerm, setSearchTerm] = useState("");
    // Calculate the items to display for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredItems = SparadRapportV2.filter((item) =>
      item.Name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const currentItems = filteredItems
    .sort((a,b) => b.isFavorite - a.isFavorite)
    .slice(indexOfFirstItem, indexOfLastItem);
    
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleClick = (event, item) => {
        setdelitem({});
        seteditem({});
        setSelectedItem(selectedItem);
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        e.stopPropagation();
        seteditem({});
        setdelitem({});
        setAnchorEl(null);
    };

    const onClickDelete = (e, item) => {
        setdelitem(item);
        seteditem({});
        e.stopPropagation();
        setAnchorEl(null);
    };

    const onClickEdit = (e, item) => {
        seteditem(item);
        setdelitem({});
        e.stopPropagation();
        setAnchorEl(null);
    };

    const DeleteThisRapport = () => {
        dispatch(onDeleteThiRapportV2(authUser.user_Afid, authUser.user_id, delitem));
        seteditem({});
        setdelitem({});
        setAnchorEl(null);
    };

    const EditThisRapport = (item) => {
        dispatch(onEditThiRapportV2(authUser.user_Afid, authUser.user_id, item));
        seteditem({});
        setdelitem({});
        setAnchorEl(null);
    };

    const handleSearchChange = (e) => {
      setSearchTerm(e.target.value);
    };
    const handleFavoriteToggle = (item) => {
      console.log(item,"isFavorile")
      let nitem = {...item,isFavorite:item.isFavorite === 1?0:1}
      dispatch(onsetThisReportAsFav(authUser.user_Afid,authUser.user_id,nitem))      
    };
    return (
        <div style={{ padding: '0px 20px' }}>
            <div style={{display:"flex", justifyContent:"space-between"}}>
            <Typography variant="h6" className={classes.title}>
                <u><IntlMessages id="Label.Favorites"/></u>
            </Typography>
            <TextField
                className={classes.searchBar}
                variant="outlined"
                size="small"
                fullWidth
                placeholder={props.intl.formatMessage({ id: 'PlaceHolder.Search.Report' })}
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />
            </div>
            
            <div className={classes.demo}>
                <List dense={true} style={{ overflowY: 'auto' }}>
                    {currentItems.map((item) => {
                        let userName = Userlista.find((item1) => parseInt(item.userid) === parseInt(item1.id));
                        return (
                            <Tooltip
                                key={item.id}
                                title={
                                    <>
                                        <p><IntlMessages id="Label.Create.Of"/>: {`${userName.FirstName} ${isEmpty(userName.LastName) ? "" : userName.LastName}`}</p>
                                        <p><IntlMessages id="Created"/>: {moment(item.sdate).format("YYYY-MM-DD")}</p>
                                        <p><IntlMessages id="Label.Report.Name1"/>: {item.Name}</p>
                                        <p>{item.Beskrivning}</p>
                                        <p>
                                            <IntlMessages id="userProfile.email" />: {item.Email}
                                        </p>
                                        <p>
                                            <u>
                                                <IntlMessages id="Filter" />
                                            </u>
                                        </p>
                                        <p>
                                            {JSON.parse(item.Chips).map((item3, index) => (
                                                <span className="mx-1" key={index}>
                                                    {item3.Meta}
                                                    {index >= JSON.parse(item.Chips).length - 1 ? "" : ", "}
                                                </span>
                                            ))}
                                        </p>
                                    </>
                                }
                            >
                                <ListItem className="border-bottom">
                                    <ListItemAvatar>
                                        <Avatar
                                            style={{ fontSize: '12px' }}
                                            className="bg-primary text-white size-30"
                                            src={userName.ProfilePicUrl}
                                        >
                                            {`${userName.FirstName[0]}${isEmpty(userName.LastName) ? "" : userName.LastName[0]}`}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={item.Name} />
                                    <ListItemSecondaryAction>
                                        <IconButton
                                            edge="end"
                                            aria-label="Favorite"
                                            size="small"
                                            color="secondary"
                                            onClick={() => handleFavoriteToggle(item)}
                                        >
                                            {item.isFavorite === 1 ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                                        </IconButton>
                                        <IconButton
                                            edge="end"
                                            aria-label="EjectIcon"
                                            size="small"
                                            color="primary"
                                            onClick={() => props.GetThisRapport(item)}
                                        >
                                            <EjectIcon />
                                        </IconButton>
                                        <IconButton
                                            edge="end"
                                            aria-label="EditIcon"
                                            size="small"
                                            color="primary"
                                            onClick={(e) => onClickEdit(e, item)}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton
                                            edge="end"
                                            aria-label="DeleteIcon"
                                            size="small"
                                            color="secondary"
                                            onClick={(e) => onClickDelete(e, item)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </Tooltip>
                        );
                    })}
                </List>
                <Pagination
                    style={{alignSelf: "end"}}
                    count={Math.ceil(SparadRapportV2.length / itemsPerPage)} // Total pages
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                />
            </div>
            {!isEmpty(delitem) ? (
                <DeleteThisSRapport item={delitem} handleClose={handleClose} DeleteThisRapport={DeleteThisRapport} />
            ) : (
                ""
            )}
            {!isEmpty(editem) ? (
                <EditThisSRapport item={editem} handleClose={handleClose} EditThisRapport={EditThisRapport} />
            ) : (
                ""
            )}
        </div>
    );
}


export default injectIntl(SparadRapport);
